import { NgModule } from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import { DxDataGridModule } from 'devextreme-angular';
import { DxFormModule } from 'devextreme-angular';
import { EmptyLayoutComponent, MainLayoutComponent } from './layouts';
import {
    ContactUsComponent,
    LoadingComponent,
    LoginComponent,
    PasswordRecoveryComponent,
    PatientSignUpComponent,
    PrivacyComponent,
    SupplyRequestComponent,
    TermsConditionsComponent,
    UserComponent,
} from './pages';
import { FusionAuthGuard } from './shared/guard';


const routes: Routes = [
    {
        path: '',
        component: EmptyLayoutComponent,
        children: [
            {
                path: 'auth-callback',
                component: LoadingComponent,
            },
            {
                path: 'login',
                component: LoginComponent,
            },
            {
                path: 'password-recovery',
                component: PasswordRecoveryComponent,
            },
            {
                path: 'patient-sign-up',
                component: PatientSignUpComponent,
            },
            {
                path: '',
                redirectTo: 'login',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: 'secured',
        component: MainLayoutComponent,
        children: [
            {
                path: 'support',
                children: [
                    {
                        path: 'contact-us',
                        component: ContactUsComponent,
                        canActivate: [FusionAuthGuard],
                        data: { roles: ['Superuser', 'Client Admin', 'Client Basic', 'Patient', 'Physician'] },
                    },
                    {
                        path: 'supply-request',
                        component: SupplyRequestComponent,
                        canActivate: [FusionAuthGuard],
                        data: { roles: ['Superuser', 'Client Admin', 'Client Basic'] },
                    }
                ],
            },
            {
                path: 'terms&conditions',
                component: TermsConditionsComponent,
                canActivate: [FusionAuthGuard],
                data: { roles: ['Superuser', 'Client Admin', 'Client Basic', 'Patient', 'Physician'] },
            },
            {
                path: 'privacy',
                component: PrivacyComponent,
                canActivate: [FusionAuthGuard],
                data: { roles: ['Superuser', 'Client Admin', 'Client Basic', 'Patient', 'Physician'] },
            },
            { path: 'results', loadChildren: () => import('./modules/features/results/results.module').then(m => m.ResultsModule) },
            { path: 'result-entry', loadChildren: () => import('./modules/features/result-entry/result-entry.module').then(m => m.ResultEntryModule) },
            { path: 'requisitions', loadChildren: () => import('./modules/features/requisitions/requisitions.module').then(m => m.RequisitionsModule) },
            { path: 'standing-orders', loadChildren: () => import('./modules/features/standing-orders/standing-orders.module').then(m => m.StandingOrdersModule) },
            { path: 'patients', loadChildren: () => import('./modules/features/patient/patient.module').then(m => m.PatientModule) },
            {
                path: 'system',
                children: [
                    {
                        path: 'users',
                        component: UserComponent,
                        canActivate: [FusionAuthGuard],
                        data: { roles: ['Superuser', 'Client Admin'] },
                    },
                ],
            },
        ],
        canActivate: [FusionAuthGuard],
    },
    {
        path: '**',
        redirectTo: 'secured/results/lab',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }), DxDataGridModule, DxFormModule],
    exports: [RouterModule],
    declarations: [],
})
export class AppRoutingModule {
}
